"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_ui_1 = require("@pasport/react-ui");
const maps_api_1 = require("maps-api");
const react_1 = require("react");
const helpers_1 = require("../../../helpers");
const Minimap_1 = require("../Minimap");
/**
 * Panorama component for rendering panorama photo
 * @param panoramaState - state with panorama data
 * @param defaultPhoto - default photo for panorama, path in public folder
 */
function Panorama({ panoramaState, defaultPhoto }) {
    const { url, close } = (0, maps_api_1.usePanorama)();
    const panoramaPoint = (0, react_1.useMemo)(() => {
        if (!url)
            return undefined;
        const point = panoramaState?.data?.panoramas?.find((p) => p.url === url);
        return point;
    }, [url, panoramaState?.data]);
    (0, react_1.useEffect)(() => {
        if (!defaultPhoto)
            throw new Error("DefaultPanoramaPhoto is not set!");
    }, [defaultPhoto]);
    return ((0, jsx_runtime_1.jsxs)(maps_api_1.PanoramaContainer, { default: defaultPhoto || "", distanceThreshold: 50 / 1000, style: {
            position: "relative",
            right: 0,
            bottom: 0,
            height: "100%",
            transform: "translate(0, -100%)",
            zIndex: 1000
        }, children: [(0, jsx_runtime_1.jsx)("div", { style: {
                    margin: 10,
                    position: "absolute"
                }, children: (0, jsx_runtime_1.jsxs)(react_ui_1.Button, { onPress: () => {
                        close();
                    }, color: "primary", children: [(0, jsx_runtime_1.jsx)("i", { className: "bi bi-arrow-left me-1" }), "Zp\u011Bt"] }) }), (0, jsx_runtime_1.jsx)("div", { style: {
                    position: "absolute",
                    right: 0,
                    bottom: 0,
                    height: 40,
                    display: "flex",
                    alignItems: "center",
                    userSelect: "none",
                    marginRight: 10,
                    opacity: 0.9
                }, className: "text-light", children: (0, jsx_runtime_1.jsxs)("small", { children: ["Po\u0159\u00EDzeno ", (0, helpers_1.formatDate)(panoramaPoint?.datum)] }) }), (0, jsx_runtime_1.jsx)("div", { style: {
                    position: "absolute",
                    right: 0,
                    bottom: 40,
                    display: "flex",
                    alignItems: "center",
                    userSelect: "none",
                    padding: 10,
                    zIndex: 1000
                }, children: (0, jsx_runtime_1.jsx)(Minimap_1.MiniMap, {}) })] }));
}
exports.default = Panorama;
